import { MessageModel } from "@/model/api/Message";
import { Shift } from "@/model/api/Shift";
import { User } from "@/model/api/User";
import {
  MessageEditor,
  ShiftAutocomplete,
  // TicketAutocomplete,
  UserAutocomplete
} from "@components";
import { messageService } from "@services/message.service";
import { Options, Vue } from "vue-class-component";
import { Watch } from "vue-property-decorator";


type MessageTarget = 'user' | 'shift';
@Options({
  components: {
    MessageEditor,
    ShiftAutocomplete,
    // TicketAutocomplete,
    UserAutocomplete
  }
})
export default class TextPage extends Vue {
  target: MessageTarget  = 'user';

  message: MessageModel = new MessageModel();

  user: User = null;

  shift: Shift = null; 

  @Watch('target')
  onTargetChange(newValue: MessageTarget, oldValue: MessageTarget) {
    if (newValue !== oldValue) {
      this[oldValue] = null;
    }
  }

  async send() {
    this.message.user_id     = this.user?.id;
    this.message.shift_id    = this.shift?.id;

    this.$waitFor( async () => {
      await messageService.send(this.message);

      this.$successMessage("Message sent");
      this.$emit("sent");

      this.reset();
    });
  }
  
  private reset() {
    this.message = new MessageModel();
  }
}